const FINANCIAL_YEAR_START_MONTH = 5;

export const getCurrentFinancialYearLabel = () => {
  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const startYear =
    currentMonth >= FINANCIAL_YEAR_START_MONTH
      ? now.getFullYear()
      : now.getFullYear() - 1;
  return `${startYear}/${startYear + 1}`;
};

export const pickDefaultDepartment = departmentOptions =>
  departmentOptions?.[0] ?? null;

export const pickDefaultFinancialYear = financialYearOptions => {
  const currentLabel = getCurrentFinancialYearLabel();
  return (
    financialYearOptions?.find(option => option.label === currentLabel) ?? null
  );
};
